export default {
      id: "nav-savings-filled-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#nav-savings-filled",
      toString: function () {
        return this.url;
      }
    }